import React, {useState} from "react";
import "./SendDocs.css";
import Category from "../../Model/Category";
import MyDataTable from "../../Components/MyDataTable/MyDataTable";
import Document from "../../Model/Document";
import AdditionnalMetadata from "../../Model/AdditionnalMetadata";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { areUploadedDocumentsLoadedAtom, areUploadedDocumentsLoadingAtom, documentMetaListAtom, justSentDocsAtom, uploadedDocumentsAtom } from "../../LoadData/LoadData";
import { useUserActions } from "../../../Connect/_actions";
import Loc from "../../../Loc/Loc";
import MySelect from "../../Components/MySelect/MySelect";
import FormDocMetadata from "../../Model/FormDocMetadata";

function define_uploadDocs_categories(uploadedDocuments: Document[], justSentDocs: Document[]) {
    let addMetas: AdditionnalMetadata[] = [];
    if (uploadedDocuments.length === 0) {
        if (justSentDocs.length === 0) {
            return [];
        }
        addMetas = justSentDocs[0].additionnalMetas;
    }
    else {
        addMetas = uploadedDocuments[0].additionnalMetas;
    }
    let categories: Category[] = [{label: Loc.trad().MyBroadcastsInternalID, field: "id"}, {label: Loc.trad().MyBroadcastsName, field: "name"}]; //, {label: "Version", field: "version"}
    addMetas.forEach((data) => {
        categories.push({label: data.name === "Indice" ? Loc.trad().MyBroadcastsID : data.name === "Status" ? Loc.trad().MyBroadcastsStatus : data.name === "Commentary" ? Loc.trad().MyBroadcastsComment : data.name, field: data.name});
    })
    return categories;
}

function define_select_filter(metadata: FormDocMetadata[]){
    var filters: {[key: string]: string} = {};

    metadata.filter(m => m.type === 3).forEach((meta: FormDocMetadata) => {
        filters[meta.name] = "";
    })
    return filters;
}

function modify_select_filter(name: string, value: string, selectedFilters: {[key: string]: string}){
    let filters: {[key: string]: string} = JSON.parse(JSON.stringify(selectedFilters));
    filters[name] = value;
    return filters;
}

export default function MyBroadcasts () {
    const userActions = useUserActions();
    const setUploadedDocuments = useSetRecoilState(uploadedDocumentsAtom);
    const setJustSentDocuments = useSetRecoilState(justSentDocsAtom);
    const setAreUploadedDocumentsLoaded = useSetRecoilState(areUploadedDocumentsLoadedAtom);
    const setAreUploadedDocumentsLoading = useSetRecoilState(areUploadedDocumentsLoadingAtom);
    const PropsUploadedDocuments: Document[] = useRecoilValue(uploadedDocumentsAtom);
    const areUploadedDocumentsLoaded: boolean = useRecoilValue(areUploadedDocumentsLoadedAtom);
    const areUploadedDocumentsLoading: boolean = useRecoilValue(areUploadedDocumentsLoadingAtom);
    const justSentDocs: Document[] = useRecoilValue(justSentDocsAtom);
    const [textInput, setTextInput] = useState("");
    const categories_mybroadcasts = define_uploadDocs_categories(PropsUploadedDocuments, justSentDocs);
    const documentMetaList = useRecoilValue(documentMetaListAtom);
    const [selectedMetaFilters, setSelectedMetaFilters] = useState(define_select_filter(documentMetaList));
    const customStyles = {
        rows: {
            style: {
                background: "white"
            },
        }
    };
    const define_uploaded_documents = () => {
        let uploadedDocuments: any = [];
        [PropsUploadedDocuments, justSentDocs].flat().forEach((doc: Document) => {
            let addMetas: AdditionnalMetadata[] = doc.additionnalMetas;
            let map = new Map<string, string>();
            map.set('id', doc.id.toString());
            // map.set('version', doc.version.toString());
            map.set('name', doc.name);
            addMetas.forEach((meta) => {
                map.set(meta.name, meta.value);
            })
            uploadedDocuments.push(Object.fromEntries(map));
        })
        return uploadedDocuments;
    }
    const data = define_uploaded_documents();

    const HandleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTextInput(event.target.value);
    }

    const addStatusFilter = (documents: any[]) => {
        let filered_documents: any[] = JSON.parse(JSON.stringify(documents));

        for (let key in selectedMetaFilters) {
            let value = selectedMetaFilters[key];
            if(value !== ""){
                filered_documents = filered_documents.filter(fm => fm[key] === value);
            }
        }
        return filered_documents;
    }

    const Refresh = () => {
        setUploadedDocuments([]);
        setJustSentDocuments([]);
        setAreUploadedDocumentsLoaded(false);
        setAreUploadedDocumentsLoading(true);
        /*userActions.getUploadedDocuments(10).then((uploadedDocuments: Document[]) => {
            setUploadedDocuments(uploadedDocuments);
        }).catch((error:any) => console.log(error))*/
        userActions.getUploadedDocuments(0).then((uploadedDocuments: Document[]) => {
            setUploadedDocuments(uploadedDocuments);
            setAreUploadedDocumentsLoaded(true);
            setAreUploadedDocumentsLoading(false);
        }).catch((error:any) => {console.log(error); setAreUploadedDocumentsLoading(false)})
    }

    return (
        <div className="MyBroadcasts">
            {documentMetaList.map((meta: FormDocMetadata, id: number) => {
                switch(meta.type){
                    case 3:
                        var options = meta.values.flat();
                        options.unshift("");
                        return(
                            <div className="Row" key={id} style={{display:"inline-flex"}}>
                                <MySelect title={meta.name === "Status" ? Loc.trad().MyBroadcastsStatus : meta.name} options={options} sendDocForm={false}
                                name={meta.name} setOption={(event) => (setSelectedMetaFilters(modify_select_filter(meta.name, event.toString(), selectedMetaFilters)))/*(event) => (console.log(event)setSelectedStatus([event.toString(), id]))*/}></MySelect>
                            </div>
                        )
                    default: return(null);
                }
            })}
            <div className="form-check form-switch" style={{ marginTop: "12px", marginBottom: "10px" }}>
                <input className="form-check-input" type="checkbox" id="NotRecep" disabled/>
                <label className="form-check-label" htmlFor="NotRecep">{Loc.trad().MyBroadcastsShow}</label>
            </div>
            <div className="row">
                <div className="col col-md-3">
                    <input className="form-control mb-2" placeholder={Loc.trad().MyBroadcastsSearch} onChange={HandleInputOnChange} />
                </div>
                <div className="col text-right">
                    <button className="btn btn-primary mb-2" onClick={Refresh} disabled={areUploadedDocumentsLoading}>{areUploadedDocumentsLoading ? Loc.trad().MyBroadcastsLoad : Loc.trad().MyBroadcastsRefresh}{areUploadedDocumentsLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : <></>}</button>
                </div>
            </div>
            <div className="datatableMyBroadcasts">
                <MyDataTable title={Loc.trad().MyBroadcastsTitle}
                    categories={categories_mybroadcasts}
                    data={addStatusFilter(data)}
                    filter={textInput}
                    expandable={false}
                    pagination={true}
                    selectable={false}
                    background={"#ececec"}
                    element={"SentDocs"}
                    customStyles={customStyles}
                    noDataString={areUploadedDocumentsLoaded ? undefined : Loc.trad().MyBroadcastsLoad2}
                ></MyDataTable>
            </div>
        </div>
    )
}